module.exports = __webpack_public_path__ + "media/bootstrap-icons/input-cursor-text-0023e736.svg";